import styled from 'styled-components';

export const OnboardingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin: 16px;
  padding: 8px 16px;

  border-radius: 8px;
  border: 0.5px solid var(--ds-border, var(--ds-fb-border));
`;

export const OnboardingHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OnboardingHeaderTextWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const OnboardingHeaderTextStyled = styled.div`
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  display: flex;
`;

export const OnboardingHeaderButtonsWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const OnboardingContentStyled = styled.div`
  display: flex;
  gap: 16px;
  padding-bottom: 8px;
`;
